// imports
import { Address } from 'abitype';
import { TransactionReceipt } from 'viem';
import { getAccount, waitForTransaction } from 'wagmi/actions';
import { IContractProps } from '../wagmi/types';
import ArbNova from '../abi/arbitrum_nova.json';
import ArbGeorli from '../abi/arbitrum_goerli.json';
import { readContract, writeContract } from '../wagmi';

// interfaces / types / consts
const L2Chain = (process.env.REACT_APP_ENVIRONMENT === 'prod' || process.env.REACT_APP_ENVIRONMENT === 'stage') ? ArbNova : ArbGeorli;
const WL_BACKPACK_ITEM = L2Chain.contracts.BackpackItems_Childchain as IContractProps;

// exports - writers
export function addItems(metaIds: string[], names: string[]): Promise<TransactionReceipt> {
  const { length } = metaIds;
  return writeContract({
    args: [metaIds, names, Array.from({ length }, () => 1), Array.from({ length }, () => 1000000)],
    abi: WL_BACKPACK_ITEM.abi,
    functionName: 'batchAddItems',
    address: WL_BACKPACK_ITEM.address,
    chainId: Number(L2Chain.chainId)
  }).then((data) => waitForTransaction({ hash: data!.hash }));
}

export function awardItems(address: Address, itemIds: bigint[], amounts: number[]): Promise<TransactionReceipt> {
  return writeContract({
    args: [address, itemIds, amounts, []],
    abi: WL_BACKPACK_ITEM.abi,
    functionName: 'mintBatch',
    address: WL_BACKPACK_ITEM.address,
    chainId: Number(L2Chain.chainId)
  }).then((data) => waitForTransaction({ hash: data!.hash }));
}

// exports - views
export function getOwned(itemIds: bigint[]): Promise<bigint[]> {
  const { address } = getAccount();
  return readContract({
    abi: WL_BACKPACK_ITEM.abi,
    functionName: 'balanceOfBatch',
    chainId: Number(L2Chain.chainId),
    address: WL_BACKPACK_ITEM.address,
    args: [itemIds.map(() => address), itemIds]
  }).then((data) => data as bigint[]);
}

// exports - default
export default { getOwned, awardItems, addItems };
